import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=6d4f7cee&scoped=true&"
import script from "./Brands.vue?vue&type=script&lang=js&"
export * from "./Brands.vue?vue&type=script&lang=js&"
import style0 from "./Brands.vue?vue&type=style&index=0&id=6d4f7cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f7cee",
  null
  
)

export default component.exports